// extracted by mini-css-extract-plugin
export var author = "main-content-module--author--b88b2";
export var authorImage = "main-content-module--authorImage--9526c";
export var authorImageContainer = "main-content-module--authorImageContainer--c0fa3";
export var bioContainer = "main-content-module--bioContainer--ee4e2";
export var contactItem = "main-content-module--contactItem--5fef5";
export var contentSidebar = "main-content-module--contentSidebar--f48fc";
export var defaultPage = "main-content-module--defaultPage--38b10";
export var heading = "main-content-module--heading--edafc";
export var item = "main-content-module--item--22d83";
export var logo = "main-content-module--logo--347fc";
export var root = "main-content-module--root--bf693";
export var sidebar = "main-content-module--sidebar--ceb2a";
export var socialMedia = "main-content-module--socialMedia--cebbd";